import {memoize} from '@sail/utils';
import locationToUrl from 'src/internal/locationToUrl';

import type {LocationParameter} from 'src/types';

export default memoize(function fullLocationToUrl(to: LocationParameter) {
  return locationToUrl({
    pathname: to.pathname,
    search: {...to.search},
    hash: to.hash,
  });
});
